var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import moment from 'moment';
import { clearTimeout, setTimeout } from 'timers';
import eventBus from '../../utils/fresh-table';
import colorSelect from '../../components/console-common/color-select.vue';
import searchInput from '../../components/console-common/search-input.vue';
import citySelect from '../../components/ins-manage/ins-select-city.vue';
import { isEquivalent } from './util.ts';
export default Vue.extend({
    components: {
        'el-select-color': colorSelect,
        'el-search-input': searchInput,
        'el-select-city': citySelect,
    },
    created: function () {
        this.searchForm = Object.assign({}, this.searchForm, this.defaultSearch); // 赋初始值 比如radio有默认选中项
    },
    data: function () {
        return {
            searchForm: {},
            searchParams: {},
            resultList: [],
            pageNo: 1,
            pageSize: 20,
            totalItemCount: 0,
            isPagination: true,
            pickerOptions: {},
        };
    },
    computed: {},
    props: {
        labelWidth: {
            type: String,
            default: '95px',
            required: false,
        },
        custPagenation: {
            type: Boolean,
            default: false,
        },
        custPageNo: {
            type: Boolean,
            default: false,
        },
        tableTitle: {
            type: String,
            default: function () {
                return '';
            },
        },
        isMountedQuery: {
            type: Boolean,
            default: true,
        },
        tableDateConfig: {
            type: Object,
            default: function () {
                return {};
            },
        },
        otherParam: {
            type: Object,
            default: function () {
                return {};
            },
        },
        mutexParam: {
            type: Object,
            default: function () {
                return {};
            },
        },
        defaultSearch: {
            type: Object,
            default: function () {
                return {};
            },
        },
        searchConfig: {
            type: Array,
            default: function () {
                return [];
            },
        },
        tableConfig: {
            type: Array,
            default: function () {
                return [];
            },
        },
        otherConfig: {
            type: Object,
            default: function () {
                return {};
            },
        },
        requestConfig: {
            type: Object,
        },
        exportConfig: {
            type: Object,
            default: function () {
                return {};
            },
        },
        flatmapRespFunc: {
            type: Function,
        },
        beforeSearchFunc: {
            type: Function,
        },
        spanConfigCallback: {
            type: Function,
            default: function () {
                return null;
            },
        },
        cellConfig: {
            type: Object,
            default: function () {
                return {};
            },
        },
        border: {
            type: Boolean,
            default: function () {
                return false;
            },
        },
    },
    mounted: function () {
        var isPagination = this.otherConfig.isPagination;
        isPagination !== undefined && (this.isPagination = isPagination);
        eventBus.$on('freshTable', this.filter);
        this.isMountedQuery && this.filter();
    },
    methods: {
        clearDate: function () {
            var _this = this;
            this.searchConfig.forEach(function (item) {
                if (item.type === 'selectDate') {
                    var val = _this.searchForm[item.dateKey];
                    if (typeof val === 'object' && val instanceof Array) {
                        _this.searchForm[item.dateKey] = [];
                    }
                }
            });
        },
        reset: function () {
            this.mutexParam.closeMutex = true;
            this.searchForm = Object.assign({}, this.defaultSearch);
            this.$emit('clear-mutex');
            this.filter();
        },
        getParams: function (checkPageNo) {
            if (checkPageNo === void 0) { checkPageNo = false; }
            var _a = this, otherParam = _a.otherParam, mutexParam = _a.mutexParam, searchForm = _a.searchForm;
            if (!mutexParam.closeMutex) {
                return Object.assign({}, mutexParam, {
                    page: this.pageNo,
                    pageSize: this.pageSize,
                });
            }
            var param = searchForm; // 默认提取查询模块的查询条件
            var params = __assign({ page: this.pageNo, pageSize: this.pageSize }, param, otherParam);
            this.searchConfig.forEach(function (item) {
                if (item.type === 'inputSearch') {
                    params[params[item.key]] = params[item.key + "_input"] || '';
                    delete params[item.key];
                    delete params[item.key + "_input"];
                }
                if (item.type === 'dateRange') {
                    var start = params[item.startTimeKey];
                    var end = params[item.endTimeKey];
                    params[item.startTimeKey] = start
                        ? moment(start).format('YYYY-MM-DD')
                        : '';
                    params[item.endTimeKey] = end ? moment(end).format('YYYY-MM-DD') : '';
                }
                if (item.type === 'date') {
                    var dateTxt = params[item.date];
                    params[item.date] = dateTxt
                        ? moment(dateTxt).format('YYYY-MM-DD')
                        : '';
                }
                if (item.type === 'dateRangeArr') {
                    var dateArr = params[item.key];
                    if (dateArr) {
                        dateArr.forEach(function (dateItem, index, targetArray) {
                            targetArray[index] = dateItem
                                ? moment(dateItem).format('YYYY-MM-DD')
                                : '';
                        });
                    }
                }
                if (item.type === 'selectDate') {
                    var dateType = params.dateType;
                    var selectDate = params[item.dateKey];
                    if (selectDate &&
                        typeof selectDate === 'object' &&
                        selectDate.length > 0) {
                        var _a = item['dateTypes'][dateType], start = _a[0], end = _a[1];
                        params[start] = moment(selectDate[0]).format('YYYY-MM-DD');
                        params[end] = moment(selectDate[1]).format('YYYY-MM-DD');
                    }
                    delete params[item.dateKey];
                    delete params.dateType;
                }
            });
            if (checkPageNo && !isEquivalent(params, this.searchParams)) {
                params.page = 1;
            }
            this.searchParams = params;
            return params;
        },
        filterBefore: function () {
            if (this.beforeSearchFunc && !this.beforeSearchFunc()) {
                return;
            }
            this.mutexParam.closeMutex = true;
            this.filter(true);
            this.$emit('clear-mutex');
        },
        filter: function (checkPageNo) {
            var _this = this;
            if (checkPageNo === void 0) { checkPageNo = false; }
            var params = this.getParams(checkPageNo); // 获得查询参数
            if (this.custPageNo) {
                params.pageNumber = params.page;
            }
            var _a = this.requestConfig, url = _a.url, method = _a.method;
            this.$request({
                url: url,
                method: method,
                data: params,
            }).then(function (res) {
                if (!res) {
                    return;
                }
                if (res.errorCode) {
                    return;
                }
                if (_this.flatmapRespFunc) {
                    _this.flatmapRespFunc(res);
                }
                if (!_this.custPagenation) {
                    var pageNo = res.pageNo, pageSize = res.pageSize, totalItemCount = res.totalItemCount, data = res.data;
                    _this.pageNo = pageNo;
                    _this.pageSize = pageSize;
                    _this.totalItemCount = totalItemCount;
                    _this.resultList = data;
                }
                else {
                    _this.resultList = res.data;
                    _this.pageNo = res.meta.current_page;
                    _this.pageSize = res.meta.per_page;
                    _this.totalItemCount = res.meta.total;
                }
            });
        },
        sizeChange: function (val) {
            this.pageSize = val;
            this.filter();
        },
        currentChange: function (val) {
            this.pageNo = val;
            this.filter();
        },
        exportData: function () {
            var _this = this;
            var _a = this.exportConfig, keyUrl = _a.keyUrl, keyMethod = _a.keyMethod;
            var params = this.getParams();
            delete params.pageNo;
            delete params.pageSize;
            this.$request({
                url: keyUrl,
                method: keyMethod || 'post',
                data: params,
            }).then(function (res) {
                if (!res || res.errorCode) {
                    return;
                }
                var key = res.data;
                _this.exportPolling(key);
            });
        },
        exportPolling: function (key) {
            var _this = this;
            var timer = null;
            var pollingMain = function (key) {
                _this.getExportStatus(key).then(function (res) {
                    if (!res || res.errorCode) {
                        return clearTimeout(timer);
                    }
                    if (!res.data) {
                        return (timer = setTimeout(pollingMain(key), 500));
                    }
                    location.href = res.data;
                    clearTimeout(timer);
                });
            };
            timer = setTimeout(function () {
                pollingMain(key);
            }, 500);
        },
        getExportStatus: function (key) {
            var _a;
            var _b = this.exportConfig, statusUrl = _b.statusUrl, statusMethod = _b.statusMethod, statusKeys = _b.statusKeys;
            return this.$request({
                url: statusUrl,
                method: statusMethod || 'post',
                data: (_a = {},
                    _a[statusKeys] = key,
                    _a),
            });
        },
        cellStyle: function (_a) {
            var row = _a.row, column = _a.column;
            var cellConfig = this.cellConfig;
            var keys = typeof cellConfig && cellConfig !== null ? Object.keys(cellConfig) : [];
            var styles = '';
            if (keys.length > 0) {
                keys.forEach(function (item) {
                    if (column.property === item) {
                        cellConfig[item].forEach(function (eItem) {
                            var status = eItem.status, style = eItem.style, flag = eItem.flag;
                            if (!flag) {
                                row[item] === status ? (styles = style) : '';
                            }
                            else {
                                row[flag] === status ? (styles = style) : '';
                            }
                        });
                    }
                });
            }
            return styles;
        },
        spanConfigMain: function () {
            // if (this.spanConfigCallback) {
            //   return this.spanConfigCallback(row, column, rowIndex, columnIndex)
            // }
        },
        btnOpe: function (callback, row) {
            callback && typeof callback === 'function' && callback(row);
        },
    },
    watch: {
        otherParam: function () {
            // update list
            this.mutexParam.closeMutex = true;
            this.filter();
        },
        mutexParam: function () {
            this.searchForm = Object.assign({}, this.defaultSearch);
            this.filter();
        },
    },
});
